import { ReactNode } from 'react';

import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Flex, Text } from '@backstage/ui';

import { GoToResourceButton } from './GoToResourceButton';

const useStyles = makeStyles({
  body: {
    flex: 1,
    minHeight: 0,
    overflow: 'auto',
  },
  loading: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: 120,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--bui-space-4)',
    height: '100%',
  },
});

interface PreviewShellProps {
  resourceName: string;
  label: string;
  loading?: boolean;
  error?: unknown;
  children: ReactNode;
}

const renderBody = (
  loading: boolean | undefined,
  error: unknown,
  classes: ReturnType<typeof useStyles>,
  children: ReactNode,
) => {
  if (loading) {
    return (
      <div className={classes.loading}>
        <CircularProgress size={24} />
      </div>
    );
  }
  if (error) {
    return (
      <Text variant="body-small" color="secondary">
        Could not load preview.
      </Text>
    );
  }
  return (
    <Flex direction="column" gap="3">
      {children}
    </Flex>
  );
};

export const PreviewShell = ({
  resourceName,
  label,
  loading,
  error,
  children,
}: PreviewShellProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.body}>
        {renderBody(loading, error, classes, children)}
      </div>
      <GoToResourceButton resourceName={resourceName} label={label} />
    </div>
  );
};
